import * as React from 'react';
import report from '@jetshop/core/errorReporting';
import { styled } from 'linaria/react';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "wwok4xg"
});
export const DefaultError = ({
  error,
  info
}) => React.createElement(Wrapper, null, React.createElement("h1", null, "Something went wrong!"), React.createElement("p", null, "Sorry! Our developers have been notified."), React.createElement("div", null, React.createElement("a", {
  href: "/"
}, "Go back to the start page")), process.env.NODE_ENV !== 'production' && React.createElement("div", null, error && React.createElement("p", null, "Error: ", error.message), info && React.createElement("pre", null, info.componentStack)));

class ErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      error: undefined,
      info: undefined
    };
  }

  componentDidCatch(error, info) {
    const {
      extraInfo = {}
    } = this.props; // Report to Sentry

    report(error, Object.assign(Object.assign({}, extraInfo), {
      reactInfo: info
    }));
    this.setState({
      error,
      info
    });
  }

  render() {
    const Comp = this.props.component;

    if (!this.state.error) {
      return this.props.children;
    }

    return React.createElement(Comp, Object.assign({}, this.state));
  }

}

ErrorBoundary.defaultProps = {
  component: DefaultError
};
export default ErrorBoundary;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ErrorBoundary/Generic.linaria.css");